<template>
  <div class="area-box">
      <el-form-item
        :label="'省' + colon"
        :label-width="labelWidth + 'px'"
        :class="{ mb16: column < 2 }"
        :required="required"
      >
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <el-select v-model="codes[areaKeys[0]]"
          placeholder="请选择省"
          filterable
          clearable
          :style="{ width: inputWidth + 'px' }"
          @change="provinceChange"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.areaCode"
            :label="item.areaName"
            :value="String(item.areaCode)"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        :label="'市' + colon"
        :label-width="labelWidth + 'px'"
        :class="{ mb16: column < 3 }"
        :required="required"
      >
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <el-select v-model="codes[areaKeys[1]]"
          placeholder="请选择市"
          filterable
          clearable
          :style="{ width: inputWidth + 'px' }"
          :disabled="!codes[areaKeys[0]]"
          @change="cityChange"
        >
          <el-option
            v-for="item in cityList"
            :key="item.areaCode"
            :label="item.areaName"
            :value="String(item.areaCode)"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        :label="'县/区' + colon"
        :label-width="labelWidth + 'px'"
        :required="required"
      >
        <!-- eslint-disable-next-line vue/no-mutating-props -->
        <el-select v-model="codes[areaKeys[2]]"
          placeholder="请选择县/区"
          filterable
          clearable
          :style="{ width: inputWidth + 'px' }"
          :disabled="!codes[areaKeys[1]]"
          @change="countyChange"
        >
          <el-option
            v-for="item in countyList"
            :key="item.areaCode"
            :label="item.areaName"
            :value="String(item.areaCode)"
          >
          </el-option>
        </el-select>
      </el-form-item>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'areaLinkage',
  props: {
    // eslint-disable-next-line vue/no-unused-properties
    propList: {
      type: Array,
      default: () => ['provinceCode', 'cityCode', 'countyCode'],
    },
    required: {
      type: Boolean,
      default: false,
    },
    labelWidth: {
      type: [Number, String],
      default: '',
    },
    inputWidth: {
      type: [Number, String],
      default: '',
    },
    column: {
      type: [Number, String],
      default: 3,
    },
    // 区域码集合
    codes: {
      type: Object,
      default: () => ({
        provinceCode: '',
        cityCode: '',
        countyCode: '',
      }),
    },
    getAreaList: {
      type: Function,
      default: () => { },
    },
    hasColon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cityList: [],
      countyList: [],
    }
  },

  computed: {
    ...mapGetters({
      provinceList: 'areaLinkageProvinceList',
    }),
    // 动态获取当前的codes的key值，注意一定是英文不能是数字类型key，不然顺序不对
    areaKeys() {
      return Object.keys(this.codes)
    },
    colon() {
      return this.hasColon ? ':' : ''
    },
  },

  watch: {
  },

  mounted() {
    this.init()
  },

  methods: {
    // 初始化当前组件的回显, 用于异步回显时操作
    init() {
      if (this.codes[this.areaKeys[0]]) {
        this.getData(2, this.codes[this.areaKeys[0]])
      }
      if (this.codes[this.areaKeys[1]]) {
        this.getData(3, this.codes[this.areaKeys[1]])
      }
    },
    // 获取值当前cloumn大于当前值
    // eslint-disable-next-line vue/no-unused-properties
    getComputed(val) {
      // alert(this.column > val)
      return this.column > val
    },

    // 省切换事件
    provinceChange(val) {
      /* eslint-disable vue/no-mutating-props */
      this.codes[this.areaKeys[0]] = val
      this.codes[this.areaKeys[1]] = ''
      this.codes[this.areaKeys[2]] = ''
      /* eslint-enable vue/no-mutating-props */
      this.cityList = []
      this.countyList = []
      this.changeHandle()
      if (val) {
        this.getData(2, val)
      }
    },

    cityChange(val) {
      /* eslint-disable vue/no-mutating-props */
      this.codes[this.areaKeys[1]] = val
      this.codes[this.areaKeys[2]] = ''
      /* eslint-enable vue/no-mutating-props */
      this.countyList = []
      this.changeHandle()
      if (val) {
        this.getData(3, val)
      }
    },

    countyChange(val) {
      // eslint-disable-next-line vue/no-mutating-props
      this.codes[this.areaKeys[2]] = val
      this.changeHandle()
    },

    // 组件的change事件
    changeHandle() {
      // [this.codes.provinceCode, this.codes.cityCode, this.codes.countyCode]

      let provinceName = ''
      let cityName = ''
      let countryName = ''


      if (this.codes[this.areaKeys[0]]) {
        const arr = this.provinceList.filter((item) => item.areaCode === this.codes[this.areaKeys[0]])
        if (arr.length) {
          provinceName = arr[0].areaName
        }
      }

      if (this.codes[this.areaKeys[1]]) {
        const arr = this.cityList.filter((item) => item.areaCode === this.codes[this.areaKeys[1]])
        if (arr.length) {
          cityName = arr[0].areaName
        }
      }

      if (this.codes[this.areaKeys[2]]) {
        const arr = this.countyList.filter((item) => item.areaCode === this.codes[this.areaKeys[2]])
        if (arr.length) {
          countryName = arr[0].areaName
        }
      }


      this.$emit('change', {
        province: {
          code: this.codes[this.areaKeys[0]],
          name: provinceName,
        },
        city: {
          code: this.codes[this.areaKeys[1]],
          name: cityName,
        },
        county: {
          code: this.codes[this.areaKeys[2]],
          name: countryName,
        },
      })
    },

    getData(type, parentCode) {
      this.getAreaList({ areaType: type, parentCode }).then(({ code, data }) => {
        if (code === 1) {
          if (type === 2) {
            this.cityList = data
          }
          if (type === 3) {
            this.countyList = data
          }
          this.changeHandle()
        }
      })
    },

    // 重置值
    // eslint-disable-next-line vue/no-unused-properties
    reset() {
      this.provinceChange('')
    },
  },
}
</script>

<style lang="scss" scoped>
.area-box ::deep .column-box > * {
  margin-bottom: 0;
  &.mb16 {
    margin-bottom: 16px !important;
  }
}
</style>
